__turbopack_context__.v({
  "accordionSlideOverwrite": "organization-hero-module-scss-module__Yif4da__accordionSlideOverwrite",
  "fadeIn": "organization-hero-module-scss-module__Yif4da__fadeIn",
  "fadeOut": "organization-hero-module-scss-module__Yif4da__fadeOut",
  "hero": "organization-hero-module-scss-module__Yif4da__hero",
  "heroImage": "organization-hero-module-scss-module__Yif4da__heroImage",
  "scaleIn": "organization-hero-module-scss-module__Yif4da__scaleIn",
  "scaleOut": "organization-hero-module-scss-module__Yif4da__scaleOut",
  "zoomIn": "organization-hero-module-scss-module__Yif4da__zoomIn",
  "zoomOut": "organization-hero-module-scss-module__Yif4da__zoomOut",
});
